import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Payment from '../pages/payment/page';
import Admin from '../pages/admin/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
  {
    path: '/payment',
    element: <Payment />
  },
  {
    path: '/admin',
    element: <Admin />
  }
];

export default routes;